import type { JSX } from 'react';
import React from 'react';

type CardTitleProps = {
  children: string | JSX.Element;
  classes?: string;
  wrapperClasses?: string;
  CustomHeadingTag?: keyof Pick<JSX.IntrinsicElements, 'h1' | 'h2' | 'h3'>;
};

function CardTitle({ children, classes, wrapperClasses, CustomHeadingTag = 'h3' }: CardTitleProps) {
  return (
    <div className={wrapperClasses}>
      <CustomHeadingTag className={classes ?? 'site-paragraph-xl text-site-neutrals-700 font-bold'}>
        {children}
      </CustomHeadingTag>
    </div>
  );
}

export default CardTitle;
